import { gsap } from 'gsap'

export function followMouse() {

  const $body = $('body')

  if($('html').hasClass('touch')) { return false }
  if(!$('.js-follow-mouse-open-video').length) { return false }

  gsap.set(".follow-cursor", { xPercent: -50, yPercent: -50, scale: 0, opacity: 0 })
  gsap.set('.follow-cursor h5', { opacity: 0})

  let xTo = gsap.quickTo(".follow-cursor", "x", {duration: 0.6, ease: "power3"}),
    yTo = gsap.quickTo(".follow-cursor", "y", {duration: 0.6, ease: "power3"})

  const $followCursor = $('.follow-cursor')

  $body.on('mousemove', '.small-video-container', function (e) {
    xTo(e.clientX)
    yTo(e.clientY)
  })

  $body.on('mouseenter', '.small-video-container video', function (e) {
    gsap.to('.follow-cursor', { scale: 1, opacity: 1, delay: 0.25, duration: 0.25 })
    gsap.to('.follow-cursor h5', { opacity: 1, delay: 0.6 })
  })

  $body.on('mouseleave', '.small-video-container video', function (e) {
    $followCursor.removeClass('is-visible')
    gsap.to('.follow-cursor', { scale: 0, opacity: 0, duration: 0.2 })
    gsap.to('.follow-cursor h5', { opacity: 0, duration: 0.2 })
  })

}
